<template>
  <el-dialog title="好友申请" :visible.sync="show" width="20%">
    <div v-if="msg">{{ msg.content }}</div>
    <div class="btn-group">
      <el-button type="danger" size="default" @click="handleRefuse"
        >拒绝</el-button
      >
      <el-button type="primary" size="default" @click="handleAgree"
        >同意</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "applyFriend",
  data() {
    return {
      show: false,
      user: null,
      msg: null,
    };
  },
  methods: {
    open(msg) {
      this.msg = msg;
      this.show = true;
    },
    close() {
      this.show = false;
    },
    handleAgree() {
      this.$http({
        url: "/friend/handle",
        method: "post",
        data: {
          relationId: this.msg.sendId,
          status: 1,
        },
      }).then(() => {
        this.$message.success("好友请求已同意");
        this.close();
      });
    },
    handleRefuse() {
      this.$http({
        url: "/friend/handle",
        method: "post",
        data: {
          relationId: this.msg.sendId,
          status: 2,
        },
      }).then(() => {
        this.$message.success("好友请求已拒绝");
        this.close();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-group {
  display: flex;
  justify-content: flex-end;
  margin: 20px 0;
}
</style>
